export const TestIds = {
  overlay: 'bannerOverlay',
  logo: 'bannerLogo',
} as const;
